import { getCssVariable } from 'uikit/utils';

const SIZE_MAPPINGS = {
  small: { fontSize: '14px', height: '34px', lineHeight: '18px' },
  medium: { fontSize: '14px', height: '42px', lineHeight: '18px' },
  large: { fontSize: '18px', height: '48px', lineHeight: '20px' },
};

export default () => ({
  control: (provided, { isDisabled, isFocused, selectProps: { size } }) => ({
    ...provided,
    borderColor: getCssVariable({
      variableKey: '--ids-color-background-primary-transparent60',
    }),
    boxShadow: isFocused && `0 0 0 2px ${getCssVariable({ variableKey: '--ids-color-primary' })}`,
    cursor: 'pointer',
    height: SIZE_MAPPINGS[size]?.height,
    minHeight: SIZE_MAPPINGS[size]?.height,
    paddingLeft: '4px',
    paddingRight: '4px',
    ...(isDisabled && {
      backgroundColor: getCssVariable({ variableKey: '--ids-color-background-primary-transparent5' }),
      borderColor: getCssVariable({ variableKey: '--ids-color-border-primary' }),
    }),
    ...(isFocused && {
      borderColor: getCssVariable({ variableKey: '--ids-color-primary' }),
      '&:hover': {
        borderColor: getCssVariable({ variableKey: '--ids-color-primary' }),
      },
    }),
    '&:hover': {
      borderColor: getCssVariable({ variableKey: '--ids-color-primary' }),
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: getCssVariable({ variableKey: '--ids-color-primary' }),
  }),
  group: (provided) => ({
    ...provided,
    padding: 0,
  }),
  groupHeading: (provided) => ({
    ...provided,
    marginBottom: 0,
    padding: '0.375rem 1.125rem',
    textTransform: 'none',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    '&:hover > div': {
      color: getCssVariable({ variableKey: '--ids-color-primary' }),
    },
  }),
  input: (provided, { selectProps: { size } }) => ({
    ...provided,
    color: getCssVariable({ variableKey: '--ids-color-primary' }),
    fontSize: SIZE_MAPPINGS[size]?.fontSize,
    fontWeight: 400,
    margin: 0,
    padding: 0,
  }),
  loadingMessage: (provided, { selectProps: { size } }) => ({
    ...provided,
    fontSize: SIZE_MAPPINGS[size]?.fontSize,
    fontWeight: 400,
  }),
  menu: (provided) => ({
    ...provided,
    maxWidth: '100%',
    minWidth: '148px',
    width: '100%',
  }),
  menuList: (provided, { options }) => ({
    ...provided,
    maxHeight: options.length === 5 ? 'auto' : '189px',
    maxWidth: '100%',
    overflowX: 'hidden',
    padding: '8px 0',
    width: '100%',
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  noOptionsMessage: (provided, { selectProps: { size } }) => ({
    ...provided,
    fontSize: SIZE_MAPPINGS[size]?.fontSize,
    fontWeight: 400,
  }),
  option: (provided, state) => ({
    ...provided,
    alignItems: 'center',
    background: state.isFocused ? getCssVariable({
      variableKey: '--ids-color-background-primary-transparent5',
    }) : 'none',
    color: 'inherit',
    border: '3px solid transparent',
    cursor: 'pointer',
    display: 'flex',
    gap: '5px',
    justifyContent: 'space-between',
    margin: '2px 0px',
    padding: '2px 8px 2px 12px',
    transition: '200ms',
    width: 'auto',
    '&:active': {
      backgroundColor: getCssVariable({
        variableKey: '--ids-color-background-primary-transparent10',
      }),
      color: getCssVariable({
        variableKey: '--ids-color-background-primary-transparent80',
      }),
    },
    '&:focus': {
      borderColor: getCssVariable({ variableKey: '--ids-color-primary' }),
      boxShadow: `0 0 0 2px ${getCssVariable({ variableKey: '--ids-color-primary' })}`,
    },
    '&:hover': {
      backgroundColor: getCssVariable({
        variableKey: '--ids-color-background-primary-transparent5',
      }),
    },
    ...(provided.isSelected && { color: 'inherit' }),
  }),
  placeholder: (provided, { isDisabled, selectProps: { size } }) => ({
    ...provided,
    color: getCssVariable({ variableKey: '--ids-color-content-secondary' }),
    margin: 0,
    ...(isDisabled && {
      color: getCssVariable({
        variableKey: '--ids-color-background-primary-transparent60',
      }),
    }),
    '> p': {
      fontSize: `${SIZE_MAPPINGS[size]?.fontSize} !important`,
      lineHeight: SIZE_MAPPINGS[size]?.lineHeight,
    },
  }),
  selectContainer: (provided, { selectProps: { isFluid } }) => ({
    ...provided,
    display: 'inline-flex',
    maxWidth: '100%',
    minWidth: 0,
    position: 'relative',
    ...(isFluid && {
      display: 'initial',
    }),
  }),
  singleValue: (provided, { isDisabled, selectProps: { size } }) => ({
    ...provided,
    color: getCssVariable({ variableKey: '--ids-color-primary' }),
    cursor: 'pointer',
    '> p': {
      fontSize: `${SIZE_MAPPINGS[size]?.fontSize} !important`,
      lineHeight: SIZE_MAPPINGS[size]?.lineHeight,
    },
    ...(isDisabled && {
      color: getCssVariable({
        variableKey: '--ids-color-background-primary-transparent60',
      }),
    }),
  }),
});
